import http from "./HttpService";
import { API_BASE_CONTENT } from "../../constants/index";
import { API_BASE_CAMPAIGN } from "./../../constants/index";
import axios from "axios";

let cancelTokenSearchArticles: any;
export function getSearchArticlesService(params: any) {
  const {
    advanced_search,
    include_sources,
    exclude_sources,
    exclude_keywords,
    include_keywords,
    campaignId,
    save,
  } = params;

  //Check if there are any previous pending requests
  if (typeof cancelTokenSearchArticles != typeof undefined) {
    cancelTokenSearchArticles && cancelTokenSearchArticles.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenSearchArticles = axios.CancelToken.source();

  const payload = new FormData();
  Object.keys(params).forEach((key) => {
    if (key === "searchTerms") {
      if (params["searchTerms"].length > 0) {
        for (let search of params["searchTerms"]) {
          payload.append("search", search);
        }
      }
    } else if (
      key === "limit" ||
      key === "offset" ||
      key === "version_id" ||
      key === "sort_by" ||
      key === "start_date" ||
      key === "end_date"
    ) {
      payload.append(key, params[key]);
    }
  });
  if (advanced_search) {
    payload.append("advanced_search", advanced_search.toString());
    if (campaignId !== undefined || campaignId !== null) {
      payload.append("campaign_id", campaignId?.toString());
    }
  }
  if (include_sources) {
    for (let item of include_sources) {
      payload.append("include_sources", JSON.stringify(item));
    }
  }
  if (exclude_sources) {
    for (let item of exclude_sources) {
      payload.append("exclude_sources", JSON.stringify(item));
    }
  }
  if (exclude_keywords) {
    for (let item of exclude_keywords) {
      payload.append("exclude_keywords", item.toString());
    }
  }
  if (include_keywords) {
    for (let item of include_keywords) {
      payload.append("include_keywords", item.toString());
    }
  }
  if (save) {
    payload.append("save", save);
  }
  return http.post(API_BASE_CONTENT + "search_articles/", payload, {
    cancelToken: cancelTokenSearchArticles.token,
  });
}
export const callSearchArticlesCancelAPI = () => {
  cancelTokenSearchArticles && cancelTokenSearchArticles.cancel("Operation canceled.");
};

export function updateKeywordsService(keywords: String[], entityId: Number, isCampaign: Number) {
  const payload = new FormData();
  for (let item of keywords) {
    payload.append("keywords", item.toString());
  }
  payload.append("campaign_id", entityId.toString());
  return http.post(API_BASE_CAMPAIGN + "update_keywords/", payload);
}

export function intentDataService(id: number, type: string) {
  return http.get(API_BASE_CONTENT + "intent_data/?id=" + id + "&type=" + type);
}
